"use client";

import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const certifications = [{
  name: "OSHA",
  description: "Authorized Occupational Safety and Health Administration Training Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587918/img/osha_logo.png"
}, {
  name: "BCSP",
  description: "Credentialed by the Board of Certified Safety Professionals",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587918/img/bcsp_logo.png"
}, {
  name: "NSC",
  description: "Active Member of the National Safety Council for Workplace Excellence",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587918/img/nsc_logo.png"
}];
export default function CertifiedLocal() {
  return <section data-section-id="127459" id="industry-credentials" className="w-full bg-background text-foreground py-6 border-y border-border/60">
      <div className="container mx-auto px-4">
        <TooltipProvider delayDuration={200}>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16 lg:gap-24">
            {certifications.map((cert, i) => <div key={cert.name} data-index={i} className="flex items-center justify-center">
                <Tooltip>
                  <TooltipTrigger className="cursor-help rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background">
                    <img src={cert.logo} alt={`${cert.name} Credential`} className="h-10 md:h-12 w-auto object-contain grayscale opacity-40 transition-all duration-300 hover:grayscale-0 hover:opacity-100" />
                  </TooltipTrigger>
                  <TooltipContent side="bottom" className="max-w-[250px] text-center bg-card border-border shadow-md">
                    <p className="text-xs md:text-sm font-medium text-foreground">{cert.description}</p>
                  </TooltipContent>
                </Tooltip>
              </div>)}
          </div>
        </TooltipProvider>
      </div>
    </section>;
}